import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

function Icon(props) {
  const IconComponent = require(`./${props.icon}`).default;

  return (
    <span className={classNames(['icon', props.className])}>
      <IconComponent />
    </span>
  );
}

Icon.displayName = 'Icon';
Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
};
Icon.defaultProps = {
  className: null,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/common/icons/Icon.js